import { DateTime } from "luxon";
import { Truth } from "../common/common-types";
import {infoStepType} from "../communications/communications-types";
import { Preset } from "./modules/schedule/schedule-types";

export class modulesType {
  course_name: string;
  status: number;
  isFavorite: boolean;
  courseID: number;
  pptImportStatus: any;
  recurrent_status: number;
  recurrent: any;
  email_cert: number;
  minimum_required_course_time_seconds: any;
  minimum_required_course_time: string;
  groupIds: number[];
  version: number;
  isExpress: number;
  categories:  object;
  date_created_timestamp: number;
  isUnpublished: boolean;
  date_last_updated: any;
  permission_type: any;
  moduleVersions: any[];
  content: any[];
  tags: any;
  expires: number;
  StudentsCourse: any[];
  certificate_details: string;

  constructor(modules?) {
    if (modules) {
      this.mapFields(modules)
    }
  }

  mapFields(modules) {
    this.certificate_details = modules.certificate_details;
    this.course_name = modules.course_name;
    this.categories = modules.categories;
    this.minimum_required_course_time = this.minimumTime(modules.minimum_required_course_time_seconds);
    this.courseID = modules.courseID;
    this.recurrent = modules.recurrent;
    this.email_cert = modules.email_cert;
    this.recurrent_status = modules.recurrent_status;
    this.isExpress = modules.isExpress;
    this.status = modules.status;
    this.pptImportStatus = modules.pptImportStatus;
    this.date_created_timestamp = Date.parse(modules.date_created);
    this.moduleVersions = modules.moduleVersions;
    this.version = modules?.version;
    this.isUnpublished = (modules.version) ? modules.version != modules?.moduleVersions.version : false;
    this.isFavorite = modules.isFavorite;
    this.content = modules.content || [];
    this.tags = modules.tags;
    this.expires = modules.expires;
    this.StudentsCourse = modules.StudentsCourse || [];

    try {
      this.groupIds = JSON.parse(modules.groupIds);
    } catch (e) {
      this.groupIds = [];
    }

    // this.isUnpublished = (this.course_name.includes("Aviation Terminology - Level 1")); //temporary placeholder, fake
  }

  minimumTime(timeInSeconds) {
    let hours = Math.floor(timeInSeconds / 60 / 60);
    let minutes = Math.floor(timeInSeconds / 60) - (hours * 60);
    return "Min: " + hours + " hr " + minutes + " min "
  }
}

export class settingsType {

  settings: settingsType;
  courseID: any;
  networkID: string;
  course_name: string;
  course_number: string;
  image: string;
  prerequisites: string;
  short_description: string;
  detailed_description: string;
  course_price: number;
  course_points: number;
  course_points_type: number;
  status: string;
  recurrent: any;
  course_navigation: any;
  navigation_lock: any;
  scorm_meta: string;
  date_created: string;
  date_last_updated: string;
  // start_date: string;
  // end_date: string;
  seconds_alloted: string;
  show_certificate: string;
  email_cert: string;
  cert_attachments: string[];
  pdf_cert: string;
  manual_mark: string;
  notify_instructor: string;
  course_currency: string;
  systemTime: string;
  systemTimeHours: string;
  systemTimeMinutes: string;
  course_summary?: any;
  ecomm: string;
  image_large?: any;
  featured: string;
  assign_course_mark: any;
  course_time_cert: any;
  practical: any;
  stickyHeader: any;
  expiration_date: string;
  expiration_period_days: number;
  show_expiration_on_certificate: any;
  email_expiration_reminder: number;
  expiration_reminder_notice_in_days: number;
  expiration_reminder_notice_in_months: number;
  expiration_reminder_repeat_period_in_days: number;
  expiration_period_months: number;
  expiration_period_years: number;
  expiration_period_type?: any;
  expiration_reminder_to_student: string;
  expiration_reminder_to_manager: string;
  expiration_reminder_email_1?: any;
  expiration_reminder_email_2?: any;
  expiration_reminder_email_3?: any;
  expiration_reminder_email_4?: any;
  expiration_reminder_email_5?: any;
  round_expiration_date_up: string;
  expires: any;
  expiration_notify_status?: any;
  repeat_expiration_reminder: string;
  expiration_type: string;
  expiration_day_month?: any;
  expiration_day_month_type?: any;
  round_expiration_date_day: string;
  minimum_required_course_time_seconds: any;
  minimum_required_course_time_hours: any;
  minimum_required_course_time_minutes: any;
  minimum_required_course_time_open_nav: any;
  help_link_destination?: any;
  show_course_mark: string;
  mark_message?: any;
  showdetails: string;
  certificate_details?: any;
  cert_logo?: any;
  transition?: any;
  template_type: string;
  recurrent_status: any;
  recurrent_type: any;
  recurrent_frequency: any;
  recurrent_date: string;
  recurrent_date_every: any;
  recurrent_notify_period?: any;
  recurrent_notify_repeat_status: any;
  recurrent_notify_repeat: any;
  recurrent_notify_student: any;
  recurrent_notify_manager: any;
  recurrent_notify_instructor: any;
  recurrent_notify_custom?: any;
  list_in_marketplace: number;
  wallet_layout?: any;
  wallet_status?: any;
  auto_assign_status: any;
  auto_assign_course_status: any;
  auto_assign_courseID?: any;
  auto_assign_date_type: any;
  auto_assign_date_period: any;
  auto_assign_date_period_type: any;
  auto_assign_date: any;
  auto_assign_retain_month?: any;
  default_header_status?: boolean;
  default_header?: any;
  default_footer_status?: any;
  default_footer?: any;
  permission_type: string;
  author_userID: number;
  version: any;
  calc_npages: string;
  phponly: string;
  courseCategory: any;
  expiration_period: string;
  expiration_reminder_emails?: any;
  auto_assign_due_date_period: any;
  auto_assign_due_date_type: any;
  assignment_notify_student: any;
  assignment_notify_manager: any;
  assignment_notify_registrar: any;
  auto_assign_due_date_period_type: any;
  assignment_notify_custom: string;
  expiration_reminder_custom: string;
  access_practical_marking: string;
  background_image?: any;
  addendums: string;
  allow_simple_editor: string;
  maximum_course_time: boolean;
  minimum_course_time: boolean;
  maximum_course_time_seconds: any;
  maximum_course_time_notify_manager: any;
  maximum_course_time_notify_instructor: any;
  groupIds: string;
  valid_period_type: any;
  valid_period_length: any;
  valid_period_interval: any;
  valid_period_after: any;
  notifyArDueDate: any;
  expressVerified: string;
  customdata?: any;
  isExpress: any;
  pptImportProgress?: any;
  pptImportStatus: string;
  pptAutoPlayPages?: any;
  id: string;
  name: string;
  number: string;
  tags: string;
  tds: any[];
  keywords: any;
  instructor: any [];
  powerpoint: {};
  backup: {};
  notifyStudent: boolean;
  notifyManager: boolean;
  notifyCustom: boolean;

  //not present in current request:
  exclude_exam_time: boolean;

  ModuleTimeCredit: string;
  MaximumModuleTimeDays: number;
  MaximumModuleTimeHours: number;
  MaximumModuleTimeMinutes: number;

  constructor(settings?, module?: modulesType) {

    //defaults

    this.settings = {
      cert_attachments : [],
      MaximumModuleTimeDays: 0,
      MaximumModuleTimeHours: 0,
      MaximumModuleTimeMinutes: 0,
      ModuleTimeCredit: null,
      access_practical_marking: "0",
      addendums: "",
      allow_simple_editor: "0",
      assign_course_mark: "0",
      assignment_notify_custom: "0",
      assignment_notify_manager: "0",
      assignment_notify_registrar: "0",
      assignment_notify_student: "0",
      author_userID: 0,
      auto_assign_course_status: 0,
      auto_assign_date: 0,
      recurrent: 0,
      auto_assign_date_period:0,
      auto_assign_date_period_type: 0,
      auto_assign_date_type: 0,
      auto_assign_due_date_period: 0,
      auto_assign_due_date_period_type: 0,
      auto_assign_due_date_type: 0,
      auto_assign_status: 0,
      auto_assign_retain_month: 0,
      calc_npages: "",
      courseCategory: 0,
      courseID: "",
      course_currency: "CAD$",
      course_name: "",
      course_navigation: "0",
      course_number: "0",
      course_points: 0,
      course_points_type: 0,
      course_price: 0,
      course_time_cert: "0",
      date_created: new Date().toISOString().slice(0, 19).replace('T', ' '),
      date_last_updated: "",
      detailed_description: "",
      ecomm: "0",
      email_cert: "1",
      email_expiration_reminder: 0,
      // end_date: "0000-00-00 00:00:00",
      exclude_exam_time: false,
      expiration_date: "0000-00-00 00:00:00",
      expiration_period: "1",
      expiration_period_days: 0,
      expiration_period_months: 0,
      expiration_period_years: 0,
      expiration_reminder_custom: "",
      expiration_reminder_notice_in_days: 0,
      expiration_reminder_notice_in_months: 0,
      expiration_reminder_repeat_period_in_days: 0,
      expiration_reminder_to_manager: "0",
      expiration_reminder_to_student: "0",
      expiration_type: "0",
      expires: false,
      expiration_notify_status: "0",
      notifyStudent: false,
      notifyManager: false,
      notifyCustom: false,
      expressVerified: "",
      featured: "0",
      groupIds: "",
      id: "",
      image: "",
      isExpress: 0,
      list_in_marketplace: 0,
      manual_mark: "0",
      maximum_course_time: false,
      minimum_course_time: false,
      maximum_course_time_notify_instructor: false,
      maximum_course_time_notify_manager: false,
      maximum_course_time_seconds: 0,
      minimum_required_course_time_open_nav: "0",
      minimum_required_course_time_seconds: 0,
      minimum_required_course_time_hours: 0,
      minimum_required_course_time_minutes: 0,
      name: "",
      navigation_lock: "1",
      networkID: "",
      notifyArDueDate: 0,
      notify_instructor: "0",
      instructor: [],
      number: "0",
      pdf_cert: "1",
      permission_type: "0",
      phponly: "0",
      pptImportStatus: "0",
      prerequisites: "0",
      practical: false,
      stickyHeader: "1",
      recurrent_date: "",
      recurrent_date_every: 0,
      recurrent_frequency: 0,
      recurrent_notify_instructor: 0,
      recurrent_notify_manager: 0,
      recurrent_notify_repeat: 0,
      recurrent_notify_repeat_status: 0,
      recurrent_notify_student: 0,
      recurrent_status: 0,
      recurrent_type: 0,
      repeat_expiration_reminder: "0",
      round_expiration_date_day: "0",
      round_expiration_date_up: "0",
      scorm_meta: "",
      seconds_alloted: "0",
      settings: undefined,
      short_description: "0",
      show_certificate: "0",
      show_course_mark: "0",
      show_expiration_on_certificate: "0",
      showdetails: "",
      // start_date: "0000-00-00 00:00:00",
      status: "0",
      systemTime: "0",
      systemTimeHours: "0",
      systemTimeMinutes: "0",
      tags : "",
      tds: [],
      template_type: "0",
      valid_period_after: "1",
      valid_period_interval: "D",
      valid_period_length: "1",
      valid_period_type: "0",
      keywords: "",
      powerpoint: {},
      backup: {},
      version: "0",

      convertTime(time): { seconds: number; mnts: number; hrs: number; days: number }
      {
        return undefined;
      },
      convertToBool(item): boolean {
        return false;
      },
    }

    if ((settings != undefined)) {
      //only on settings, not saving

      this.settings = settings;
      this.settings.expires = (settings.expires == '1');
      this.settings.expiration_notify_status = (settings.expiration_notify_status == '1');
      this.settings.show_expiration_on_certificate = (settings.expiration_notify_status == '1');
      this.settings.recurrent_status = (settings.recurrent_status == '1');
      this.settings.recurrent = settings.recurrent == '1'
      this.settings.default_header_status = (settings.default_header_status == '1');
      this.settings.default_footer_status = (settings.default_footer_status == '1');
      this.settings.course_navigation = (settings.course_navigation == '1');
      this.settings.navigation_lock = (settings.navigation_lock == '1');
      this.settings.auto_assign_retain_month = (settings.auto_assign_retain_month == '1');
      this.settings.assign_course_mark = (settings.assign_course_mark == '1');
      this.settings.notifyArDueDate = (settings.notifyArDueDate == '1')
      this.settings.minimum_required_course_time_open_nav = (settings.minimum_required_course_time_open_nav == '1');
      this.settings.courseCategory = settings.courseCategory || 0;
      this.settings.stickyHeader = (settings.stickyHeader == '1');
      this.settings.practical = (settings.practical == '1');
      this.settings.maximum_course_time_notify_manager = (settings.maximum_course_time_notify_manager == '1');
      this.settings.maximum_course_time_notify_instructor = (settings.maximum_course_time_notify_instructor == '1');
      this.settings.assignment_notify_student = (settings.assignment_notify_student == "1");
      this.settings.assignment_notify_manager = (settings.assignment_notify_manager == "1");
      this.settings.assignment_notify_registrar = (settings.assignment_notify_registrar == "1");
      this.settings.course_time_cert = (settings.course_time_cert == "1");
      this.settings.instructor = settings.instructor || [];
      this.settings.expiration_period =(settings.expiration_period == 0) ? 1 : settings.expiration_period;
      this.settings.auto_assign_due_date_period = (settings.auto_assign_due_date_period == 0) ? 1 : settings.auto_assign_due_date_period;
      this.settings.auto_assign_due_date_type = (settings.auto_assign_due_date_type == "0") ? "D" : settings.auto_assign_due_date_type;
      this.settings.assignment_notify_custom = settings.assignment_notify_custom;
      this.settings.auto_assign_course_status = settings.auto_assign_course_status;
      this.settings.valid_period_after = settings.valid_period_after || 1;

      this.settings.expiration_period_type = settings.expiration_period_type == "0" ? "D" : settings.expiration_period_type
      this.settings.course_number = (settings.course_number != "") ? parseInt(settings.course_number) : settings.course_number;
      this.settings.version = (settings.version) ? parseInt(settings.version) : 0;
      // this.settings.keywords = [];
      this.settings.tags = settings.tags;
      this.settings.MaximumModuleTimeDays = this.convertTime(settings.maximum_course_time_seconds).days || 0;
      this.settings.MaximumModuleTimeHours = this.convertTime(settings.maximum_course_time_seconds).hrs || 0;
      this.settings.MaximumModuleTimeMinutes = this.convertTime(settings.maximum_course_time_seconds).mnts || 0;
      this.settings.maximum_course_time = settings.MaximumModuleTimeDays > 0 || settings.MaximumModuleTimeHours > 0 || settings.MaximumModuleTimeMinutes > 0;
      this.settings.minimum_required_course_time_hours = this.convertTime(settings.minimum_required_course_time_seconds).hrs || 0;
      this.settings.minimum_required_course_time_minutes = this.convertTime(settings.minimum_required_course_time_seconds).mnts || 0;
    }
  }

  convertTime(time) {
    let seconds = parseInt(time, 10);
    let days = Math.floor(seconds / (3600 * 24));
    seconds -= days * 3600 * 24;
    let hrs = Math.floor(seconds / 3600);
    seconds -= hrs * 3600;
    let mnts = Math.floor(seconds / 60);
    seconds -= mnts * 60;
    return {days, hrs, mnts, seconds}
  }

  convertToBool(item) {
    return item == '1'
  }
}

export let Dates = {
  "D": "Days",
  "W": "Weeks",
  "M": "Months",
  "Y": "Years"
}
export let Dates2 = {
  "D": "Day",
  "W": "Week",
  "M": "Month",
  "Y": "Year"
}

export let statuses = {
  "drafts": 0,
  "published": 1,
  "archived": 2
}

export class moduleInfo {

  author_userID: any;
  category_id: any;
  category_name: any;
  course_number: any;
  created: any;
  desc: any;
  detailed_description: any;
  exams: any;
  exams_questions: any;
  expires: any;
  image: any;
  instructorList: any;
  instructor_id: any;
  lastModified: any;
  modified: any;
  name: any;
  pages: any;
  permission_type: any;
  read_only: any;
  recurrent_status: any;
  review_questions: any;
  surveys: any;
  addendum: any;

  constructor(info?) {
    Object.assign(this, info);
  }
}

export interface storeType {
  network: {}
  modules: Map<number, modulesType>
  selectedModule: modulesType
  selectedModules: Map<number, modulesType>,
  filters: any;
  filteredResults: any;
  searchResults: modulesType[];
  searchTermResults: any[];
  settings: settingsType;
  searchTerm: string;
  instructors: any[];
  moduleInfo: moduleInfo;
  groups: any[]
  categories: any[]
  authors: any[]
  tags: any;
  versions: {}
  currentInfoText: infoStepType
  modulePresets: Preset[],
}

export interface setAction {
  module_id: number,
  status_action: string
}

export let permissionList = [
  "Open (read/write available to all TD's)",
  "Restricted (Choose from list of TD's for read/write access, hidden from others)",
  "Private (Author TD and a 'master' TD can see it)"
]

interface contentType {
  content_id: any
  page_id: any
  page_name: string

}

export class SearchResults {
  name: string
  id: number
  status: string
  content: contentType[]

  constructor(results, id) {
    this.id = id;
    this.name = results.course_name
    this.status = results.status
    this.content = results.data
  }
}

export class NotificationSettings {

  id: number;
  type: string;
  userID: number;
  objectID: number;
  settings:  SettingsForNotification


  constructor() {
    this.mapFields();
  }

  private mapFields() {
    this.id = 0;
    this.type = notificationTypes[5];
    this.userID = 0;
    this.objectID = 0;
    this.settings = new SettingsForNotification();

  }
}

export const notificationTypes = [
  "competency",
  "doc",
  "event",
  "futureOlte",
  "moduleArDue",
  "moduleDue",
  "moduleExpiry",
  "olte"
]

export class SettingsForNotification {

  student: SettingsForNotificationTypes
  manager: SettingsForNotificationTypes
  other: SettingsForNotificationTypes[]

  constructor() {
    this.student = {email: "", notify: 0, period: "0", periodType: "D", repeatDays: "0"}
    this.manager = {email: "", notify: 0, period: "0", periodType: "D", repeatDays: "0"}
    this.other = [];

  }
}

interface SettingsForNotificationTypes {
  "notify": number,
  "period": string,
  "periodType": string,
  "repeatDays": string,
  "email": string,

}

let example = {
  "student": {"notify": 1, "period": "21", "periodType": "Y", "repeatDays": "4", "email": ""},
  "manager": {"notify": 1, "period": "21", "periodType": "Y", "repeatDays": "4", "email": ""},
  "other": [{
    "notify": 1,
    "period": "21",
    "periodType": "Y",
    "repeatDays": "4",
    "email": "fdsfds@sdsd.com"
  }, {"notify": 1, "period": 9, "periodType": "Y", "repeatDays": "4", "email": "rertr@sddefdfd.com"}],
  "misc": {"expiry_notes": false}
}

export interface ModuleCertificateAttachmentData {
  attachmentId: number;
  itemType: string;
  itemId: number;
  path: string;
}

export interface ModuleCertificateDestinationData {
  cc_2: Truth;
  cc_6: Truth;
  courseID: number;
  created?: string | DateTime;
  custom1: string;
  custom2: string;
  custom3: string;
  id?: number;
  modified?: string | DateTime;
  network_id?: number;
}
export interface ModuleCertificateData {
  certificate_attachments: ModuleCertificateAttachmentData[]
  module_certificate_email_destinations: ModuleCertificateDestinationData
}

export const infoText = {

  name: "This is the name that will appear in the training records and on certificates. It is suggested that you include some detail to make it clear what this module is and include anything about its version. " +
    "<br><br><strong>Examples:</strong> <br>" +
    "Bad: Safety | Good: Warehouse Safety Orientation <br>" +
    "Bad: HPSR | Good: High Platform Safety Rigging Versions: Forklift Operation - 2015 Forklift Operation 2.0 <br>" +
    "<br><strong>Special Characters:</strong> <br>" +
    "We recommend avoiding use of special characters in Module Names, especially if you intend to export to or integrate with any other database.<br>" +
    "Characters to avoid: ‘ / | “ < > { } # ! <br>" +
    "OK: - _ & + * ( ) :",
  category: "You can create categories for your modules in Registrar / Settings / Customization / Offline Training and Personal Documents / “Categories” button. Then you can put this module into one of those categories to sort them by category in certain areas.",
  author: "By default the module’s author is the person logged in as Training Developer who created the module. However, you can select from the menu list (users with 'Training Developer' role assigned) one or more other people who are authors of the module. Currently this is for your reference only, however it may be used in future features.",
  keywords: "Keywords help you organize and search for particular modules",
  logo: "The module logo will show on the students home and training pages beside the module listing. The image you upload will be automatically scaled to a size of 80 x 80 pixels.",
  powerPoint: "Your uploaded presentation will create a new module.<br><br> <span style='color:red' ><strong>IMPORTANT:</strong></span> After your PowerPoint is uploaded there is a file processing time, usually several minutes but may take up to 24 hours depending on PPT content and system load. An email notification will be sent (to the address for this account you are signed in with) when processing is complete or if an error is encountered. The completed PPT will be in the new module you created, which will be in your ‘Drafts’ in Training Developer. Refer to the ‘Help’ for further info.",
  "Select from existing preset": "Select from  previously saved preset to fill existing settings.",
  "Expiry Date": "Set when this training will expire. This is a time frame after the student has completed their training.",
  "Show expiry date on certificate": "Shows date when the training will expire on the certificate.",
  "valid for": "The validity period for training is the grace period during which the training is active for the student after completion.",
  "Email Notification": "Set notifications for: Students, Manager or Custom Recipients. Students and manager can have a custom and recurrent delivery schedule.",
  "Assign Date": "Set the time when the new module should be assigned to the student.",
  "Assign to module": "Select next version of the module to be assigned to the student once this module expires. Alternatively, you can re-assign current module.",
  "Email Destinations": "Email notifications that goes out notifying the selected group in regards to the  recurring training. For example: New module as been assigned or is about to expire.",
  "Retain same expiry date": "If the student completes the original module before the training expires, you can retain the expiry of that module for the reassigned training.",
  "New module is due": "Set a deadline when this module is due by. You can set this window before or after module expiry.",
  "Create New Preset" : "Save the existing settings as a preset that can be applied to another module.",
  "Auto-Recurring" : "Will automatically assign next module to the student",
  "Advanced Settings" : "Additional settings for recurring training including notifications and assignment date",
  "Instructors" : "Assign an Instructor role to the person(s) who are experts in the module's subject matter in Registrar/People/Staff. Then, in Module Settings assign those instructor(s) to the Module. The instructor(s) assigned to the module can then score any 'manually scored' exam(s) in the module, and also can be the destination for the 'Module Help' (see setting below).",
  "Practical Component" : "Turn this option ON if this online module is the THEORY component of training that also requires a PRACTICAL / HANDS-ON / LAB exercise to be done in order to complete this training. When the Student completes the online module, the module is NOT shown as complete, but rather it shows Pending Practical until the appropriate Manager or Instructor logs into their role and checks off the Practical for the student, as per a list of 'Students Waiting for Practical' they will see when they sign in. Either the Manager of the Student Group the Student is in (set in Registrar/People/Staff/Actions), or the Instructor(s) of the Module (set in Module Settings) will be able to sign in and confirm when the Practical component is completed. You must select the Manager or Instructor or Both to be able to do this. After the Practical Component is checked off as complete, THEN the Module Certificate will be emailed (if it is turned on).",
  "Pre-requisite" : "You can enter a pre-requisite for this module. This currently has no function and is just for reference.",
  "Module Help Destination" : "If you select either Coach or Instructor role from this menu, then a Help Message button appears in the module header and the student can click it to type in and send a message to either the Instructor for this module or the Student’s assigned ‘Coach’. The system will include a hyperlink in that message which will take the Instructor/Coach to the page the message was sent from. Of course, you need to assign Instructor(s) to the module or Coach to the student for this to work.",
  "Minimum Module Time" : "This forces the Student to remain active within the module for a set amount of time. If you have an operations manual that says you provide a certain amount of time training on a particular subject, then you should set the minimum module time to meet or exceed that time. It is strongly advised to put a regular Content page at the very end of the module which has hyperlinks to or attachments of related subject matter which the Student can read if they finish the module before the Min Module Time has elapsed.",
  "Custom Header" : "A default header for every page in the module. Typically you would put company name and logo here. If you turn it on, the editor for the header will appear.",
  "Custom Footer": "A default footer for every page in the module. Typically you would put copyright notice here (i.e.: “Copyright 2015 Acme Corp. DO NOT PRINT”). If you turn it on, the editor for the footer will appear.",
  "Show Navigation" : "This setting creates an 'open book' module. Students will be able to move backand forth through the module pages AND exams. Note: This setting overrides the 'Show Navigation on Retake' exam setting.",
  "Lock Navigation" : "If Show Navigation option above is turned ON, student can skip ahead to any pagein the module, including the end. If you turn ON this Lock, each page is un-locked inthe navigation pane as the Student visits it, thus they can click back to any page theyhave already visited, but can not skip ahead.It is strongly recommended to have this ON if you have turned on ‘Show Navigation’ option.",
  "Module name stays on top in student browser" : "The module name header stays on top of the student's training browser when a user scrolls so that the module name always shows.",
  "Show Navigation On Last Page" : "This is used when a course has a Minimum Course Time set for it. If student gets to last page of course and they are unable to Submit the course because there is time remaining, they will see a link: 'REVIEW COURSE MATERIAL NOW'. Clicking that link will open the NAV ('page navigation') pane. The student can then freely go to any page in the entire course. Note: The course will be put into REVIEW mode: Review Questions are locked and can not be re-answered. Any Exam(s) in the course are locked in their completed state. Any Survey(s) in the course are locked in their completed state.",
  "Show Module Time On Certificate" :"This will show the value for the course length on the bottom left of the Course Completion Certificate, just above the Student's e-mail address. It will be displayed as: Course Length: x Hours, x Minutes or Course Length: x Hours",
  "Exclude Exam Time": "This basically 'stops the clock' while Student is in an Exam in the module. It excludes the Exam time from the total ‘Module Time’ (time the student spent in the module) in reports, AND it excludes the Exam time being counted toward ‘Minimum Module Time’ and ‘Maximum Module Time’ when those settings are turned ON.",
  "Supplementary Logo": "This is an ADDITIONAL, smaller logo that appears in the bottom left area of the Module Certificate. Examples of this logo: 'ISO 9001', 'Quality #1', 'International Sales Division'. The image you add here will be constrained to 125 x 60 pixels (landscape orientation), so you need to make your logo image a .jpg or .png which is 125 pixels wide by 60 pixels high or it will appear skewed or possibly have too large a file size.",
  "Show Module Mark" : "This creates a Mark for this module and shows that on the Module Certificate. The Module Mark is the AVERAGE of all Exam Scores inside that module. There is an option to include a 'Mark Message' which will show on the Module Certificate. You can enter something here if you like. Typical message examples: 'Corrected to 100% with James Hoover', 'Practical Exercise Score: 95%', 'Further Practice Required'"
}



